// extracted by mini-css-extract-plugin
export default {"rootContainer":"DndMain_rootContainer__7+laW"};